module.exports = __webpack_public_path__ + "img/PL10041.30e87b00.png";